import {
  FormControl,
  Stack,
  TextField,
  Typography,
  Switch,
  OutlinedInput,
  InputLabel,
  InputAdornment,
} from "@mui/material";
import Utils from "../../core/Utils";
import DecimalEntryField from "./controls/DecimalEntryField";
import { useEffect, useState } from "react";
import { UEABusinessSetTaxPercent } from "../../core/Constants";
import CountryHelper from "../../core/CountryHelper";
import { connectToStore } from "../../data/store";
import { getBranch } from "../../data/localSettingsActions";

const SalesInfoComponent = ({
  inclusiveOfTax,
  setInclusiveOfTax,
  cost,
  setCost,
  priceExclusive,
  setPriceExclusive,
  taxPercentage,
  setTaxPercentage = CountryHelper.IsBusinessCountryUAE() ? UEABusinessSetTaxPercent : taxPercentage,
  totalPrice,
  setTotalPrice,
  taxAmount,
  setTaxAmount,
  costMandatory = true,
  customProduct = false,
  isUAEBusiness = false,
  qty,
  setQTY
}) => {

  const [municipalTax, setMunicipalTax] = useState("");
  const [isAllowMunicipalTax, setIsAllowMunicipalTax] = useState(false);
  const [localSettings, setLocalSettings] = useState({});
  const [municipalTaxAmount, setMunicipalTaxAmount] = useState("");


  useEffect(() => {
    let localSetting = connectToStore();
    setLocalSettings(localSetting);
    if(CountryHelper.IsBusinessCountryUAE()) {
      checkMuncipalTaxApplicable(localSetting)
    }
    
  },[])

  useEffect(() => {
    if(inclusiveOfTax && isAllowMunicipalTax) {
      onChangeMuncipalTax();
    }
  },[inclusiveOfTax]);

  useEffect(() => {
    calculateTaxAmount();
  }, [taxPercentage, priceExclusive, totalPrice,isAllowMunicipalTax]);

  const checkMuncipalTaxApplicable = (localSetting) => {  
    if(localSetting.branch.isAllowMunicipalTax) {
      setIsAllowMunicipalTax(true);
      let muncipalTax = localSetting.branch.municipalTax
      setMunicipalTax(muncipalTax);
    }
  }

  const onChangeMuncipalTax = () => {
    if (totalPrice && inclusiveOfTax) {
      const _totalPrice = Utils.ConvertToFloat(totalPrice);
      const _municipalTax = Utils.ConvertToFloat(municipalTax);
      const _taxPercent = Utils.ConvertToFloat(taxPercentage);
  
      const totalTaxPercent = _municipalTax + _taxPercent;
  
      // Base price (exclusive of both taxes)
      const basePrice = +(_totalPrice / (1 + totalTaxPercent / 100)).toFixed(2);
      const _municipalTaxAmount = +(basePrice * (_municipalTax / 100)).toFixed(2);
      const _taxAmount = +(basePrice * (_taxPercent / 100)).toFixed(2);
  
      // Set states
      setPriceExclusive(basePrice.toFixed(2));
      setMunicipalTaxAmount(_municipalTaxAmount.toFixed(2));
      setTaxAmount(_taxAmount.toFixed(2));
    }
  };
  
  

  const calculateTaxAmount = () => {
    if(taxPercentage && !isAllowMunicipalTax) {
      var _totalPrice = Utils.ConvertToFloat(totalPrice);
    var _taxExcludedPrice = Utils.ConvertToFloat(priceExclusive);
    var _taxAmount = _totalPrice - _taxExcludedPrice;
    setTaxAmount(_taxAmount.toFixed(2));
    }
    else if (isAllowMunicipalTax) {
      onChangeMuncipalTax();
    }
  };

  const onChangeTax = (value) => {
    const regex = /^\d*\.?\d{0,2}$/;
    if (!regex.test(value)) {
      return;
    }
    setTaxPercentage(value);
    var _totalPrice = Utils.ConvertToFloat(totalPrice);
    var _taxPercent = Utils.ConvertToFloat(value);
    var _taxExcludedPrice = Utils.ConvertToFloat(priceExclusive);
    if (inclusiveOfTax) {
      _taxExcludedPrice = (_totalPrice / (_taxPercent + 100)) * 100;
      setPriceExclusive(_taxExcludedPrice.toFixed(2));
    } if(inclusiveOfTax && isAllowMunicipalTax) {
      var _muncipalTax = Utils.ConvertToFloat(municipalTax);
      _taxExcludedPrice = (_taxExcludedPrice / (_muncipalTax + 100)) * 100;
      setPriceExclusive(_taxExcludedPrice.toFixed(2));
    } else {
      _totalPrice = (_taxExcludedPrice * (_taxPercent + 100)) / 100;
      setTotalPrice(_totalPrice.toFixed(2));
    }
  };

  const onChangeSellingprice = (value) => {
    onChangePrice(value);
    setCost(value);
  }
  const setTaxPrecentage = () => {
    var _taxPercent;
    if (isUAEBusiness) {
      var setTaxPercent = Utils.IsNullOrEmpty(taxPercentage) ? UEABusinessSetTaxPercent : taxPercentage
      _taxPercent = Utils.ConvertToFloat(setTaxPercent);
    }
    else {
      _taxPercent = Utils.ConvertToFloat(taxPercentage);
    }
    return _taxPercent;
  }
  const onChangePrice = (value) => {
    if (!inclusiveOfTax) {
      setPriceExclusive(value);
      var _taxPercent = setTaxPrecentage();
      var _taxExcludedPrice = Utils.ConvertToFloat(value);
      var _totalPrice = (_taxExcludedPrice * (_taxPercent + 100)) / 100;
      setTotalPrice(_totalPrice.toFixed(2));
    }
  };

  const onChangeTotalPrice = (value) => {
    if (inclusiveOfTax) {
      setTotalPrice(value);
      var _taxPercent = setTaxPrecentage();
      var _totalPrice = Utils.ConvertToFloat(value);
      var _taxExcludedPrice = (_totalPrice / (_taxPercent + 100)) * 100;
      setPriceExclusive(_taxExcludedPrice.toFixed(2));
    }
  };

  if (isUAEBusiness) {
    return (
      <Stack direction="column" spacing={2}>
        {getBranch()?.isTaxBracket && (
          <Stack alignItems="center">
            <div
              style={{
                backgroundColor: "#fdecea",
                color: "#b71c1c",
                padding: "12px 16px",
                border: "1px solid #f5c6cb",
                borderRadius: "4px",
                width: "100%",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              VAT has been disabled. Please ensure your business complies with local tax regulations.
            </div>
          </Stack>
        )}
        <Stack
          direction="row"
          spacing={2}
          alignItems="baseline"
          justifyContent="space-between"
          sx={{ justifyContent: "flex-end" }}
          className="font-size-14"
        >
          <Typography>Inclusive of Tax</Typography>
          <Switch
            sx={{ justifyContent: "flex-end" }}
            checked={inclusiveOfTax}
            onChange={() => setInclusiveOfTax(!inclusiveOfTax)}
          />
        </Stack>
        <Stack direction="row" spacing={2}>
          <FormControl fullWidth>
            <DecimalEntryField
              inputProps={{ style: { fontSize: 13 } }}
              label="Purchasing Cost"
              type="number"
              value={cost}
              setError={costMandatory}
              setValue={onChangeSellingprice}
              placeholder="Enter cost"
            />
          </FormControl>
          <FormControl fullWidth>
            {inclusiveOfTax ? (
              <DecimalEntryField
                inputProps={{
                  style: { fontSize: 13 },
                  maxLength: 7,
                }}
                setError={true}
                label="Selling Price"
                type="number"
                value={totalPrice}
                setValue={onChangeTotalPrice}
                placeholder="Enter price"
              />
            ) : (
              <DecimalEntryField
                inputProps={{
                  style: { fontSize: 13 },
                  maxLength: 7,
                }}
                setError={true}
                label="Selling Price"
                type="number"
                value={priceExclusive}
                setValue={onChangePrice}
                placeholder="Enter price"
              />
            )}
          </FormControl>
        </Stack>
        <Stack direction="row" spacing={2}>
          <FormControl fullWidth>
            <DecimalEntryField
              inputProps={{ style: { fontSize: 13 } }}
              label="Quantity "
              type="number"
              value={qty}
              setError={true}
              setValue={setQTY}
            />
          </FormControl>

          <FormControl fullWidth>
          <InputLabel htmlFor="TaxPercentage">Tax Percent</InputLabel>
            <OutlinedInput
              inputProps={{ style: { fontSize: 13 } }}
              label="Tax Percent"
              type="number"
              endAdornment={<InputAdornment position="end"> <span style={{ fontSize: '1.5rem' }}>%</span></InputAdornment>}
              disabled={getBranch()?.isTaxBracket}
              value={taxPercentage}
              onChange={(e) => onChangeTax(e.target.value)}
            />
          </FormControl>
        </Stack>
        {isAllowMunicipalTax && inclusiveOfTax && <Stack direction="row" spacing={2}>
         <FormControl fullWidth>
                <InputLabel htmlFor="MuncipalTax">Municipality Tax</InputLabel>
                <OutlinedInput
                  id="MuncipalTax"
                  inputProps={{ style: { fontSize: 13 } }}
                  label="Muncipality Tax"
                  type="number"
                  value={municipalTax}
                  readonly={true}
                  placeholder="Enter tax"
                  disabled
                  endAdornment={<InputAdornment position="end"> <span style={{ fontSize: '1.5rem' }}>%</span></InputAdornment>}
                />
              </FormControl>
              <FormControl fullWidth>
                <TextField
                  inputProps={{
                    style: { fontSize: 13 },
                    maxLength: 7,
                  }}
                  value={municipalTaxAmount}
                  label="Municipal Tax Amount"
                  disabled
                ></TextField>
              </FormControl>
        </Stack>}
        {inclusiveOfTax && (
          <Stack direction="row" spacing={2}>
            <FormControl fullWidth>
              <TextField
                value={priceExclusive}
                label="Price Exclusive of Tax"
                variant="outlined"
                disabled
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                value={taxAmount}
                label="Tax Amount"
                variant="outlined"
                disabled
              />
            </FormControl>
          </Stack>
        )}
      </Stack>
    );
  }
  else if (customProduct) {
    return (
      <Stack direction="column" spacing={2}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="baseline"
          justifyContent="space-between"
          sx={{ justifyContent: "flex-end" }}
          className="font-size-14"
        >
          <Typography>Inclusive of Tax</Typography>
          <Switch
            sx={{ justifyContent: "flex-end" }}
            checked={inclusiveOfTax}
            onChange={() => setInclusiveOfTax(!inclusiveOfTax)}
          />
        </Stack>
        <Stack direction="row" spacing={2}>
          <FormControl fullWidth>
            <DecimalEntryField
              inputProps={{ style: { fontSize: 13 } }}
              label="Quantity "
              type="number"
              value={qty}
              setError={true}
              setValue={setQTY}
            />
          </FormControl>
          <FormControl fullWidth>
            {inclusiveOfTax ? (
              <DecimalEntryField
                inputProps={{
                  style: { fontSize: 13 },
                  maxLength: 7,
                }}
                setError={true}
                label="Selling Price"
                type="number"
                value={totalPrice}
                setValue={onChangeTotalPrice}
              />
            ) : (
              <DecimalEntryField
                inputProps={{
                  style: { fontSize: 13 },
                  maxLength: 7,
                }}
                setError={true}
                label="Selling Price"
                type="number"
                value={priceExclusive}
                setValue={onChangePrice}
              />
            )}
          </FormControl>
        </Stack>
        <Stack direction="row" spacing={2}>
          <FormControl fullWidth>
            <DecimalEntryField
              inputProps={{ style: { fontSize: 13 } }}
              label="Purchasing Cost"
              type="number"
              value={cost}
              setError={costMandatory}
              setValue={setCost}
              placeholder="Enter cost"
            />
          </FormControl>
          <FormControl fullWidth>
            <DecimalEntryField
              inputProps={{ style: { fontSize: 13 } }}
              label="Tax Percent"
              type="number"
              value={taxPercentage}
              setValue={onChangeTax}
              placeholder="Enter tax percent"
            />
          </FormControl>
        </Stack>
        {inclusiveOfTax && (
          <Stack direction="row" spacing={2}>
            <FormControl fullWidth>
              <TextField
                value={priceExclusive}
                label="Price Exclusive of Tax"
                variant="outlined"
                disabled
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                value={taxAmount}
                label="Tax Amount"
                variant="outlined"
                disabled
              />
            </FormControl>
          </Stack>
        )}
      </Stack>
    );
  }
  else {
    return (
      <>
        <Stack
          direction="row"
          spacing={2}
          alignItems="baseline"
          justifyContent="space-between"
          style={{ marginBottom: "10px" }}
          className="mt-3"
        >
          <Typography
            level="h3"
            component="h3"
            className="title-lbl"
          >Sales Info</Typography>
          <Stack
            direction="row"
            spacing={2}
            alignItems="baseline"
            justifyContent="space-between"
            sx={{ justifyContent: "flex-end" }}
            className="font-size-14"
          >
            <Typography>Inclusive of Tax</Typography>
            <Switch
              sx={{ justifyContent: "flex-end" }}
              checked={inclusiveOfTax}
              onChange={() => setInclusiveOfTax(!inclusiveOfTax)}
            />
          </Stack>
        </Stack>
        {!inclusiveOfTax ? (
          <Stack direction="row" spacing={2}>
            <FormControl fullWidth>
              <DecimalEntryField
                inputProps={{ style: { fontSize: 13 } }}
                label="Cost "
                type="number"
                value={cost}
                setError={costMandatory}
                setValue={setCost}
                placeholder="Enter cost"
              />
            </FormControl>
            <FormControl fullWidth>
              <DecimalEntryField
                inputProps={{
                  style: { fontSize: 13 },
                  maxLength: 7,
                }}
                setError={true}
                label="Price Exclusive of Tax"
                type="number"
                value={priceExclusive}
                setValue={onChangePrice}
                placeholder="Enter price"
              />
            </FormControl>
            <FormControl fullWidth>
              <DecimalEntryField
                inputProps={{ style: { fontSize: 13 } }}
                label="Tax Percentage"
                type="number"
                value={taxPercentage}
                setValue={onChangeTax}
                placeholder="Enter tax percent"
              />
            </FormControl>
          </Stack>
        ) : (
          <Stack direction="column" spacing={2}>
            <Stack direction="row" spacing={2}>
              <FormControl fullWidth>
                <DecimalEntryField
                  inputProps={{ style: { fontSize: 13 } }}
                  label="Cost "
                  type="number"
                  value={cost}
                  setError={costMandatory}
                  setValue={setCost}
                  placeholder="Enter cost"
                />
              </FormControl>
              <FormControl fullWidth>
                <DecimalEntryField
                  inputProps={{
                    style: { fontSize: 13 },
                    maxLength: 7,
                  }}
                  setError={true}
                  label="Total Price"
                  type="number"
                  value={totalPrice}
                  setValue={onChangeTotalPrice}
                  placeholder="Enter price"
                />
              </FormControl>
              <FormControl fullWidth>
                <InputLabel htmlFor="TaxPercentage">Tax Percentage</InputLabel>
                <OutlinedInput
                  id="TaxPercentage"
                  inputProps={{ style: { fontSize: 13 } }}
                  label="Tax Percentage"
                  type="number"
                  endAdornment={<InputAdornment position="end"> <span style={{ fontSize: '1.5rem' }}>%</span></InputAdornment>}
                  value={taxPercentage}
                  onChange={(e) => onChangeTax(e.target.value)}
                  placeholder="Enter tax"
                />
              </FormControl>
              {isAllowMunicipalTax && <FormControl fullWidth>
                <InputLabel htmlFor="MuncipalTax">Municipality Tax</InputLabel>
                <OutlinedInput
                  id="MuncipalTax"
                  inputProps={{ style: { fontSize: 13 } }}
                  label="Muncipality Tax"
                  type="number"
                  value={municipalTax}
                  disabled
                  readonly={true}
                  placeholder="Enter tax"
                  endAdornment={<InputAdornment position="end"> <span style={{ fontSize: '1.5rem' }}>%</span></InputAdornment>}
                />
              </FormControl>}
            </Stack>
            <Stack direction="row" spacing={2}>
              <FormControl xs={8} fullWidth>
                Price Excluded Tax:
                <TextField
                  inputProps={{
                    style: { fontSize: 13 },
                  }}
                  value={priceExclusive}
                  disabled
                ></TextField>
              </FormControl>
              <FormControl xs={8} fullWidth>
                Tax Amount:
                <TextField
                  inputProps={{
                    style: { fontSize: 13 },
                    maxLength: 7,
                  }}
                  value={taxAmount}
                  disabled
                ></TextField>
              </FormControl>
              {isAllowMunicipalTax && <FormControl xs={8} fullWidth>
                Municipal Tax Amount:
                <TextField
                  inputProps={{
                    style: { fontSize: 13 },
                    maxLength: 7,
                  }}
                  value={municipalTaxAmount}
                  disabled
                ></TextField>
              </FormControl>}
            </Stack>
          </Stack>
        )}
      </>
    );
  }
};
export default SalesInfoComponent;
